import get from "lodash/get";
import {
    postInvoiceClientItemLoading,
    postInvoiceClientItemReject,
    postInvoiceClientItemRequest,
    postInvoiceClientItemSuccess,
    postInvoiceClientItemReset,
} from "../../actions/invoiceClient/postItem";

export const postInvoiceClientItem = (body) => async (dispatch, getState) => {
    dispatch(postInvoiceClientItemLoading());
    try {
        const { data } = await postInvoiceClientItemRequest(body, getState);
        dispatch(postInvoiceClientItemSuccess(data));
    } catch (error) {
        dispatch(postInvoiceClientItemReject(get(error, "response.data", error)));
    } finally {
        setTimeout(() => { dispatch(postInvoiceClientItemReset()); }, 3000);
    }
    return Promise.resolve();
};
